export default __webpack_public_path__ + "static/media/frame-overseer.6955bf85.png";